import {debounceFn} from '../utils/debounce.js';

interface EmperaFilterChangedEvent {
  reductionFilter: boolean;
  isLowStockFilter: boolean;
}

let lastDispatchedData: EmperaFilterChangedEvent | undefined = undefined;

export const dispatchEmperaFilterChangedEvent = debounceFn((data: EmperaFilterChangedEvent) => {
  if (JSON.stringify(lastDispatchedData) !== JSON.stringify(data)) {
    lastDispatchedData = data;
    document.dispatchEvent(new CustomEvent('empera:wishlist:newsletter-ssi:change', {
      detail: data
    }));
  }
}, 500);
